import { css } from "styled-components";

const backgroundColoursCss = (backgroundColors: string[] | undefined) => {
  let percentageMultiplier = 0;
  let backgroundGradientColors = "";

  // Return empty css if no colours are given
  if (!backgroundColors || backgroundColors.length === 0) {
    return css``;
  }

  // Return a single colour if 1 colour is given
  if (backgroundColors.length === 1) {
    return css`
      background: ${backgroundColors[ 0 ]};
    `;
  }

  // Set the percentageMultiplier
  percentageMultiplier = 100 / (backgroundColors.length - 1) / 100;

  // Generate the backgroundGradientColors string
  backgroundColors.map((color, i) => {
    let percentage = 100 * (i * percentageMultiplier);

    // Force the 1st colour percentage to 0
    if (i === 0) {
      percentage = 0;
    }

    // Force the last colour percentage to 100
    if (i === backgroundColors.length - 1) {
      percentage = 100;
    }

    backgroundGradientColors = `${backgroundGradientColors}, ${color} ${percentage}%`;
  });

  // Return a gradient if multiple colours are given
  return css`
    background: ${backgroundColors[ 0 ]};
    background: -webkit-linear-gradient(-45deg ${backgroundGradientColors});
    background: linear-gradient(135deg ${backgroundGradientColors});
  `;
};

export default backgroundColoursCss;
